import React from 'react';
import { FieldArray } from "redux-form";
import { inventarioInicialFields } from "../camposInventario";


const InventarioInicialSection = ({ readOnlyMode = false, sucursales, isEdit, onNext, onPrevious, canGoNext, canGoPrevious }) => {

    if (isEdit) return null;

    return (
        <div className="section-panel">

            <div className="section-header">
                <h4>Inventario Inicial por Sucursal</h4>
                {!readOnlyMode && (
                <div className="section-actions">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onPrevious}
                        disabled={!canGoPrevious}
                    >
                        Regresar
                    </button>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onNext}
                        disabled={!canGoNext}
                    >
                        Siguiente
                    </button>
                </div>
                )}
            </div>

            <p className="text-muted">
                Define existencias y costo de compra inicial por sucursal.
            </p>


            <div className="w-100 text-muted small mb-2">
                    Elige una sucursal para indicar cuántas unidades iniciales tiene y su costo de compra. Puedes agregar varias sucursales si lo necesitas.
            </div>   
            <FieldArray
                name="inventario_inicial"
                component={inventarioInicialFields}
                sucursales={sucursales}
                readOnlyMode={readOnlyMode}
            />

        </div>
    );
};

export default InventarioInicialSection;